<template>
  <v-container>
    <v-snackbar
      v-model="infoAction.snackbar"
      :color="infoAction.color"
      top="top"
    >
      {{ infoAction.message }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="infoAction.snackbar = false">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <div><b> Popup</b></div>
    <br /><br />
    <v-card class="pa-2">
      <div class="d-flex align-center">
        <v-text-field
          v-model="searchPopup"
          label="cari"
          outlined
          dense
          hide-details
        ></v-text-field>
        <v-btn
          @click="(isCreate = true), (dialogBuatPopup = true)"
          :style="{
            background: 'linear-gradient(to right, #c90000, #f9c72a)',
            color: 'white'
          }"
          class="white--text ml-2"
          >Tambah</v-btn
        >
      </div>
      <v-data-table
        :search="searchPopup"
        class="mt-2"
        :headers="headers"
        :items="listPopup"
      >
        <template v-slot:[`item.jenis`]="{ item }">
          <div>
            {{ item.id_banner ? 'Banner' : 'Iklan' }}
          </div>
        </template>
        <template v-slot:[`item.id_direct`]="{ item }">
          <div>
            {{ item.id_banner ? item.id_banner : item.id_iklan }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div :style="item.status == 1 ? 'color:#c90000' : 'color:#af0000'">
            {{ item.status == 1 ? 'Aktif' : 'Tidak Aktif' }}
          </div>
        </template>
        <template v-slot:[`item.gambar`]="{ item }">
          <viewer>
            <img
              :id="'gambar' + item.id"
              width="50px"
              class="ma-2"
              height="40px"
              :src="$url_img + item.foto"
              alt=""
            />
          </viewer>
        </template>
        <template v-slot:[`item.aksi`]="{ item }">
          <div class="d-flex align-center">
            <v-icon @click="goToEdit(item)">mdi-pencil-outline</v-icon>
            <v-icon @click="(tempPopup = item), (dialogDeletePopup = true)"
              >mdi-trash-can-outline</v-icon
            >
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogBuatPopup" width="500px" persistent>
      <v-card class="pa-3">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">
            {{ isCreate ? 'Tambah ' : 'Edit ' }} Data Popup
          </h4>
          <v-icon @click="clearFormPopup()">mdi-close</v-icon>
        </div>
        <br />
        <div>
          <v-text-field
            label="Judul"
            outlined
            hide-details
            dense
            v-model="formPopup.judul"
          ></v-text-field>
          <v-select
            outlined
            class="mt-3"
            :items="jenisId"
            hide-details
            dense
            v-model="pickJenisId"
            item-text="jenis"
            item-value="id"
            label="Direction"
          ></v-select>
          <v-text-field
            class="mt-3"
            :label="pickJenisId == 1 ? 'ID Banner' : 'ID Iklan'"
            v-model="formPopup.id_direct"
            outlined
            hide-details
            dense
          ></v-text-field>
          <v-file-input
            class="mt-3"
            label="Gambar Popup"
            outlined
            id="inputFotoPopup"
            v-model="formPopup.foto"
            dense
            :style="formPopup.preview_foto ? 'display:none' : ''"
            @change="uploadFoto()"
            prepend-inner-icon="mdi-image-area"
            prepend-icon=""
          ></v-file-input>
          <v-card outlined class="pa-2 mt-3" v-if="formPopup.preview_foto">
            <div class="d-flex align-center">
              <viewer>
                <img
                  id="preview_popup"
                  width="50px"
                  height="40px"
                  :src="
                    formPopup.preview_foto.includes('popup/foto/')
                      ? $url_img + formPopup.preview_foto
                      : formPopup.preview_foto
                  "
                />
              </viewer>
              <v-spacer></v-spacer>
              <v-btn
                @click="document.getElementById('inputFotoPopup').click()"
                small
                color="#c90000"
                class="white--text"
                >ubah
                <v-icon class="ml-2 " small>mdi-pencil-outline</v-icon></v-btn
              >
              <v-btn
                @click="document.getElementById('preview_popup').click()"
                small
                class="ml-2 white--text"
                color="#c90000"
                >Preview
                <v-icon small class="ml-2">mdi-eye-outline</v-icon></v-btn
              >
            </div>
          </v-card>
          <div class="mt-2" v-if="!isCreate">
            <v-checkbox
              v-model="formPopup.is_aktif"
              label="Aktifkan Popup ?"
              color="#c90000"
              hide-details
            ></v-checkbox>
          </div>
        </div>
        <v-btn
          width="100%"
          :disabled="
            !formPopup.preview_foto || !formPopup.judul || !formPopup.id_direct
              ? true
              : false
          "
          :style="{
            background: 'linear-gradient(to right, #c90000, #f9c72a)',
            color: 'white'
          }"
          @click="isCreate ? postBuatPopup() : putEditPopup()"
          class="white--text mt-3"
          >{{ isCreate ? 'simpan' : 'update' }}</v-btn
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletePopup" width="400px" persistent>
      <v-card class="pa-3">
        <div class="d-flex justify-space-between align-center">
          <div style="color: white">X</div>
          <h4 style="color: #c90000">
            Delete Popup
          </h4>
          <v-icon @click="(dialogDeletePopup = false), (tempPopup = null)"
            >mdi-close</v-icon
          >
        </div>
        <br />
        <div v-if="tempPopup">
          <v-card outlined class="pa-2">
            <div class="d-flex align-center">
              <viewer>
                <img
                  id="preview_popup_delete"
                  width="50px"
                  height="40px"
                  :src="$url_img + tempPopup.foto"
                />
              </viewer>
              <v-spacer></v-spacer>
              <v-btn
                @click="document.getElementById('preview_popup_delete').click()"
                small
                class="ml-2 white--text"
                color="#c90000"
                >Preview
                <v-icon small class="ml-2">mdi-eye-outline</v-icon></v-btn
              >
            </div>
          </v-card>
          <div class="my-2">
            anda yakin ingin menghapus popup "{{ tempPopup.judul }}" ?
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="deletePopup()" outlined color="#BD251C">Hapus</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
import moment from 'moment';
Vue.use(Viewer);
export default {
  data() {
    return {
      searchPopup: '',
      infoAction: {
        snackbar: false,
        message: '',
        color: ''
      },
      listPopup: [],
      dialogDeletePopup: false,
      document,
      users: null,
      headers: [
        { text: 'Judul', value: 'judul' },
        { text: 'Jenis', value: 'jenis' },
        { text: 'ID Direct', value: 'id_direct' },
        { text: 'Status', value: 'status' },
        { text: 'Gambar', value: 'gambar' },
        { text: 'Aksi', value: 'aksi' }
      ],
      tempPopup: null,
      dialogBuatPopup: false,

      //   form banner
      jenisId: [
        {
          id: 1,
          jenis: 'Banner'
        },
        {
          id: 2,
          jenis: 'Iklan'
        }
      ],
      pickJenisId: 1,
      formPopup: {
        id_popup: '',
        foto: null,
        preview_foto: null,
        judul: '',
        id_direct: '',
        is_aktif: true
      },
      isCreate: true
    };
  },
  filters: {
    countDoc(doc) {
      if (doc !== null) {
        return true;
      }
    },
    datediff: date => {
      return moment(date).from();
    },
    dateFormat: date => {
      return moment.utc(date).format('DD MMM YYYY');
    },
    timeFormat: date => {
      return moment.utc(date).format('HH:mm');
    },
    dateTimeFormat: date => {
      return moment.utc(date).format('DD MMM YYYY HH:mm');
    }
  },
  methods: {
    async getPopup() {
      let params = new URLSearchParams();

      //   params.set('id_mst_order_jenis_iklan', 1);

      //   var offset = (this.offset = (this.page - 1) * this.limit);
      //   params.append('offset', offset);
      //   params.append('limit', this.limit);

      var request = {
        params: params,
        headers: { Authorization: 'Bearer ' + this.users.token }
      };
      await this.$req
        .get(this.$root.$baseapi.iklan + '/iklan/v3/popup/admin', request)
        .then(response => {
          let { data } = response.data;
          this.listPopup = data == null ? [] : data;
          //   var mod = response.data.count % this.limit;
          //   var lengthPage = 0;

          //   lengthPage = (response.data.count - mod) / this.limit;

          //   if (mod == 0) {
          //     this.lengthPage = lengthPage;
          //   } else {
          //     this.lengthPage = lengthPage + 1;
          //   }
          console.log('list refund tiket', this.listPopup);
        })
        .catch(error => {
          let responses = error.response.data;
          console.log(responses.api_message);
        });
    },
    clearFormPopup() {
      this.jenisId = [
        {
          id: 1,
          jenis: 'Banner'
        },
        {
          id: 2,
          jenis: 'Iklan'
        }
      ];
      this.pickJenisId = 1;
      this.formPopup = {
        id_popup: '',
        foto: null,
        preview_foto: null,
        judul: '',
        id_direct: '',
        is_aktif: true
      };
      this.tempPopup = null;
      this.dialogBuatPopup = false;
      this.dialogDeletePopup = false;
    },
    uploadFoto() {
      if (this.formPopup.foto) {
        this.formPopup.preview_foto = URL.createObjectURL(this.formPopup.foto);
      } else {
        this.formPopup.preview_foto = null;
      }
    },
    async postBuatPopup() {
      //   console.log('popup', this.formPopup);
      let formData = new FormData();

      formData.set('judul', this.formPopup.judul);
      formData.set('foto', this.formPopup.foto);
      if (this.pickJenisId == 1) {
        formData.set('id_banner', this.formPopup.id_direct);
      } else {
        formData.set('id_iklan', this.formPopup.id_direct);
      }

      await this.$req
        .post(this.$root.$baseapi.iklan + '/iklan/v3/popup', formData, {
          headers: { Authorization: 'Bearer ' + this.users.token }
        })
        .then(response => {
          // this.color.snackbar = 'success';
          // this.message = response.data.api_message;
          // this.snackbar = true;

          this.clearFormPopup();
          this.getPopup();
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    async putEditPopup() {
      console.log('popup', this.formPopup);
      let formData = new FormData();
      formData.set('id', this.formPopup.id_popup);
      formData.set('judul', this.formPopup.judul);
      formData.set('status', this.formPopup.is_aktif ? 1 : 2);
      if (this.formPopup.foto) {
        formData.set('foto', this.formPopup.foto);
      }
      if (this.pickJenisId == 1) {
        formData.set('id_banner', this.formPopup.id_direct);
      } else {
        formData.set('id_iklan', this.formPopup.id_direct);
      }
      await this.$req
        .put(this.$root.$baseapi.iklan + '/iklan/v3/popup', formData, {
          headers: { Authorization: 'Bearer ' + this.users.token }
        })
        .then(response => {
          // this.color.snackbar = 'success';
          // this.message = response.data.api_message;
          // this.snackbar = true;
          this.clearFormPopup();
          this.getPopup();
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    async deletePopup() {
      //   console.log('popup', this.formPopup);
      let formData = new FormData();

      formData.set('id', this.tempPopup.id);

      await this.$req
        .post(this.$root.$baseapi.iklan + '/iklan/v3/popup/delete', formData, {
          headers: { Authorization: 'Bearer ' + this.users.token }
        })
        .then(response => {
          // this.color.snackbar = 'success';
          // this.message = response.data.api_message;
          // this.snackbar = true;

          this.clearFormPopup();
          this.getPopup();
          this.infoAction = {
            snackbar: true,
            message: response.data.api_message,
            color: 'success'
          };
        })
        .catch(error => {
          let responses = error.response.data;
          this.infoAction = {
            snackbar: true,
            message: responses.api_message,
            color: 'error'
          };
        });
    },
    goToEdit(item) {
      this.tempPopup = item;
      this.pickJenisId = item.id_banner ? 1 : 2;
      this.formPopup = {
        id_popup: item.id,
        foto: null,
        preview_foto: item.foto,
        judul: item.judul,
        id_direct: item.id_banner ? item.id_banner : item.id_iklan,
        is_aktif: item.status == 1 ? true : false
      };
      this.isCreate = false;
      this.dialogBuatPopup = true;
    }
  },
  created() {
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);
    this.getPopup();
  }
};
</script>

<style></style>
